import React from 'react';

import classes from './MealHeaderRow.module.scss';
import {
  GridTableCell,
  GridTableRow,
} from '../../../../shared/components/table-components';
import { InfoTooltip } from '../../../../shared/components/ui-components';
import { MACRO_NUTRIENT_HINTS } from '../../../constants/mealPlanMacros';

const MealHeaderRow = () => {
  return (
    <GridTableRow variant="unstyled" className={classes.tableHeader}>
      <GridTableCell>Name</GridTableCell>
      <GridTableCell className={classes.infoCell}>
        <span>Proteins</span>
        <InfoTooltip>
          Proteins must be divisible by {MACRO_NUTRIENT_HINTS.proteins}
        </InfoTooltip>
      </GridTableCell>
      <GridTableCell className={classes.infoCell}>
        <span>Carbs</span>
        <InfoTooltip>Carbs must be divisible by {MACRO_NUTRIENT_HINTS.carbs}</InfoTooltip>
      </GridTableCell>
      <GridTableCell className={classes.infoCell}>
        <span>Fats</span>
        <InfoTooltip>Fats must be divisible by {MACRO_NUTRIENT_HINTS.fats}</InfoTooltip>
      </GridTableCell>
      <GridTableCell>Calories</GridTableCell>
    </GridTableRow>
  );
};

export { MealHeaderRow };
